import React, { memo } from 'react';
import { Input, Select, Checkbox, Switch, Upload } from 'antd';
import FormItem from '../FormItem';
import { types } from './constants';
import DatePicker from './DatePicker';
import EditableField from '../EditableField';
import DropdownSelect from '../../../../../components/dropdownSelect';
import TimePicker from './TimePicker';
import DspxEditor from '../../../../../components/DspxEditor';
import OptionButtonGroup from './OptionButtonGroup';

const fields = {
  [types.datePicker]: DatePicker,
  [types.timePicker]: TimePicker,
  [types.editableInput]: EditableField,
  [types.dropdownSelect]: DropdownSelect,
  [types.input]: Input,
  [types.select]: Select,
  [types.checkboxGroup]: Checkbox.Group,
  [types.checkbox]: Checkbox,
  [types.optionBtnGroup]: OptionButtonGroup,
  [types.editor]: DspxEditor,
  [types.switch]: Switch,
  [types.uploadDragger]: Upload.Dragger,
  [types.textarea]: Input.TextArea,
};

const Field = ({
  type,
  formItemLabel,
  required,
  errorMessage,
  rootCN,
  colon = false,
  formItemValidateStatus,
  formItemHelp,
  formItemExtra,
  ...props
}) => {
  const FieldComponent = fields[type];

  return (
    <FormItem
      label={formItemLabel}
      required={required}
      error={errorMessage}
      className={rootCN}
      colon={colon}
      validateStatus={formItemValidateStatus}
      help={formItemHelp}
      extra={formItemExtra}
    >
      <FieldComponent {...props} />
    </FormItem>
  );
};

Field.types = types;
Field.Memoized = memo(Field);

export default Field;
